import React, {useCallback, useEffect, useMemo, useRef, useState} from 'react'

import EntitySelectorUsersSearch from "./search"
import EntitySelectorUsersList from "./list"
import {MentionOption} from "../../../editor/plugins/mentions/option"
import {EntityType} from "../../../../gd/const/item"

type Props = {
    userMentions    : MentionOption[]

    onEntitySelected: {(entity:MentionOption):void}
    onTab           : {():void}
}

const debug = false
// const debug = "EntitySelectorUsers"

export default function EntitySelectorUsers (props:Props) {
    const [search, setSearch]   = useState('')
    const [options, setOptions] = useState<MentionOption[]>([])
    const listRef               = useRef<any>()

    const userMentions = useMemo(()=>{
        return _.map(props.userMentions.slice(), mention=>{
            mention.type = EntityType.USER
            return mention
        })
    }, [props.userMentions])

    const onSearchChanged = useCallback((search:string)=>{
        setSearch(search)
    }, [])

    useEffect(()=>{
        const searchString = search?.toLowerCase()

        const res: MentionOption[] = []
        _.map(userMentions, (option:any)=>{
            if (option.name.toLowerCase().includes(searchString)) res.push(option)
        })
        setOptions(res)
    }, [search])

    const onKeyDown = useCallback((event: any)=>{
        listRef.current.onKeyDown(event)
    }, [listRef.current])

    return (
        <>
            <EntitySelectorUsersSearch searchDebounceTime   = {0}
                                       onKeyDown            = {onKeyDown}
                                       onSearchChanged      = {onSearchChanged}/>
            <EntitySelectorUsersList ref                = {listRef}
                                     search             = {search}
                                     options            = {options}
                                     onEntitySelected   = {props.onEntitySelected}
                                     onTab              = {props.onTab}/>
        </>
    )
}
